import ReactPaginate from 'react-paginate';

const Pagination = (props) => {
    const { page, pageCount, onPageChange } = props;

    return (
        <div className="d-flex fade-in tab-pagination" id="dissociated-pagination">
            <nav className="okc-pagination ml-auto">
                <ReactPaginate
                    previousLabel={
                        <svg width="24" height="24">
                            <path
                                d="M14.2893 5.70708C13.8988 5.31655 13.2657 5.31655 12.8751 5.70708L7.98768 10.5993C7.20729 11.3805 7.2076 12.6463 7.98837 13.427L12.8787 18.3174C13.2693 18.7079 13.9024 18.7079 14.293 18.3174C14.6835 17.9269 14.6835 17.2937 14.293 16.9032L10.1073 12.7175C9.71678 12.327 9.71678 11.6939 10.1073 11.3033L14.2893 7.12129C14.6799 6.73077 14.6799 6.0976 14.2893 5.70708Z"
                                fill="#0F0F0F"
                            />
                        </svg>
                    }
                    nextLabel={
                        <svg width="24" height="24" style={{ transform: 'rotateZ(180deg)' }}>
                            <path
                                d="M14.2893 5.70708C13.8988 5.31655 13.2657 5.31655 12.8751 5.70708L7.98768 10.5993C7.20729 11.3805 7.2076 12.6463 7.98837 13.427L12.8787 18.3174C13.2693 18.7079 13.9024 18.7079 14.293 18.3174C14.6835 17.9269 14.6835 17.2937 14.293 16.9032L10.1073 12.7175C9.71678 12.327 9.71678 11.6939 10.1073 11.3033L14.2893 7.12129C14.6799 6.73077 14.6799 6.0976 14.2893 5.70708Z"
                                fill="#0F0F0F"
                            />
                        </svg>
                    }
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    forcePage={page ? Math.max(0, page - 1) : 0}
                    onPageChange={onPageChange}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    activeClassName="active"
                    previousClassName="page-item prev"
                    nextClassName="page-item next"
                    disabledClassName="disabled"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    prevPageRel="null"
                    nextRel="null"
                    nextPageRel="null"
                    selectedPageRel="null"
                />
            </nav>
        </div>
    );
};

export default Pagination;
